export default function HelperText({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <div className="flex gap-x w-full  ">
      <span className="flex w-[8px] h-[8px] bg-orange_light_1 rounded-[50%] mt-x"></span>

      {children}
    </div>
  );
}
